import { Router } from '@angular/router';

router: Router;

export module LocalVariable {

    
    export function saveAuth(data: any, email: string){
        localStorage.setItem("maplerace_auth", data.token);
        localStorage.setItem("maplerace_stravaConnect", data.stravaConnect);
        localStorage.setItem("maplerace_isPrenium", data.prenium);
        localStorage.setItem("maplerace_email", email.toLowerCase());
    }

    export function checkLogIn(router){
        if(isLoggedIn()){
			let redirect =  '/dashboard';
			router.navigate([redirect]);
		}
    }

    export function isLoggedIn(){
        return (localStorage.getItem("maplerace_auth") !== null) && (localStorage.getItem("maplerace_email") !== null)
    }

    export function isPrenium(){
        return (localStorage.getItem("maplerace_isPrenium") === "true");
    }

    export function isStravaConnected(){
        return (localStorage.getItem("maplerace_stravaConnect") === "true");
    }

    export function logOut(router){
        localStorage.removeItem("maplerace_auth");
        localStorage.removeItem("maplerace_stravaConnect");
        localStorage.removeItem("maplerace_isPrenium");
        localStorage.removeItem("maplerace_email");
        let redirect =  '/login';
        router.navigate([redirect]);
    }

}
